import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import "@fontsource/inter/latin-300.css";
import "@fontsource/inter/latin-400.css";
import "@fontsource/inter/latin-500.css";
import "@fontsource/inter/latin-600.css";
import "@fontsource/inter/latin-700.css";
import "@fontsource/radio-canada-big/latin-400.css";
import "@fontsource/radio-canada-big/latin-500.css";
import "@fontsource/radio-canada-big/latin-600.css";
import "@fontsource/radio-canada-big/latin-700.css";

import { NotFound } from "@/components/not-found";
import { LoadedClerk, SignedInSessionResource, UseAuthReturn } from "@clerk/react/types";

interface Context {
  auth: UseAuthReturn;
  session: SignedInSessionResource | null;
  clerk: LoadedClerk;
}

export const Route = createRootRouteWithContext<Context>()({
  component: RootComponent,
  notFoundComponent: () => <NotFound />,
});

function RootComponent() {
  return <Outlet />;
}
